'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TypeMappingSelect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _apiTypeMapping = require('../../actions/esdb/apiTypeMapping');

var _reactRedux = require('react-redux');

var _forms = require('@esnpm/forms');

var _nodeToolbox = require('@esnpm/node-toolbox');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeMappingSelect = exports.TypeMappingSelect = (_dec = (0, _reactRedux.connect)(function (state) {
	return { TypeMappings: state.TypeMappings };
}), _dec(_class = (_temp = _class2 = function (_ESForm$Field) {
	_inherits(TypeMappingSelect, _ESForm$Field);

	function TypeMappingSelect(props) {
		_classCallCheck(this, TypeMappingSelect);

		var _this = _possibleConstructorReturn(this, (TypeMappingSelect.__proto__ || Object.getPrototypeOf(TypeMappingSelect)).call(this, props));

		_this.state = {
			options: [{ value: "loading", text: "loading..." }]
		};
		return _this;
	}

	_createClass(TypeMappingSelect, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			_get(TypeMappingSelect.prototype.__proto__ || Object.getPrototypeOf(TypeMappingSelect.prototype), 'componentWillMount', this).call(this);
			this.props.dispatch((0, _apiTypeMapping.apiTypeMapping)({ SET: this.props.set })).then(function () {
				var ret = [];
				_this2.props.typemapping.data[_this2.props.set].OPTIONS.map(function (v) {
					ret.push({
						value: v.NAME,
						textTr: "typeMapping." + _this2.props.set + "." + v.NAME
					});
				});
				_this2.options = ret;
				_this2.setState({
					options: ret
				});
			});
		}
	}, {
		key: 'renderInput',
		value: function renderInput(props) {
			props.options = this.state.options;
			props.value = this.props.value;
			props.ignoreValueUpdates = true;

			props.sortEntries = this.props.sortEntries;

			return _react2.default.createElement(_forms.ESInput.Select, _extends({}, props, { ref: "select" }));
		}
	}]);

	return TypeMappingSelect;
}(_forms.ESForm.Field), _class2.defaultProps = Object.assign({}, _forms.ESForm.Field.defaultProps, {
	fieldName: "TYPE_MAPPING_SELECT"
}), _class2.propTypes = Object.assign({}, _forms.ESForm.Field.propTypes, {
	set: _propTypes2.default.string.isRequired
}), _temp)) || _class);